import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, boolean, required, mixed} from "yup";
import CooperationFormFields from './CooperationFormFields'

class CooperationForm extends React.Component {

    render() {
        const {
            values,
        } = this.props;


        return <CooperationFormFields {...this.props}/>

    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            board_id: props.board.id,
            day_contract: '',
            day_contract_start: '',
            day_contract_end: '',
            payment: '',
        });
    },

    // validationSchema: () => {
    //     let rules = object().shape({
    //
    //     });
    //
    //     return rules
    // },

    handleSubmit: (values, {props}) => {
        axios.post(props.formUrl, values).then(() => {
            swal({
                icon: "success",
                title: i18n.get('cooperations.save_success'),
                text: i18n.get('cooperations.you_will_be_redirected'),
                timer: 4000,
            }).then(() => {
                window.location.href = props.redirectAfterSubmit
            })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('cooperations.ajax_error'),
            })
        })
    },

    validateOnBlur: true

})(CooperationForm)

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    }
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Cooperations/CooperationForm.js